import React from 'react';
import { FormField } from '../../../../components/FormField';
import { FormRow } from '../../../../components/FormRow';

interface PromotionCommonAreasProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

export const PromotionCommonAreas: React.FC<PromotionCommonAreasProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-900 dark:text-white">Équipements communs</h4>

      <FormRow>
        <FormField label="Nombre de blocs/bâtiments">
          <input
            type="number"
            name="number_of_blocks"
            value={property?.number_of_blocks ?? formData.number_of_blocks ?? 1}
            onChange={handleInputChange}
            min="1"
          />
        </FormField>

        <FormField label="Nombre d'ascenseurs par bloc">
          <input
            type="number"
            name="elevators_per_block"
            value={property?.elevators_per_block ?? formData.elevators_per_block ?? 0}
            onChange={handleInputChange}
            min="0"
          />
        </FormField>
      </FormRow>

      <FormField label="Type de parking">
        <select
          name="parking_type"
          value={property?.parking_type || formData.parking_type || ''}
          onChange={handleInputChange}
          className="w-full"
        >
          <option value="">Sélectionner</option>
          <option value="sous-sol">Sous-sol</option>
          <option value="extérieur">Extérieur</option>
          <option value="mixte">Mixte</option>
        </select>
      </FormField>

      <FormField label="Espaces techniques et services">
        <div className="grid grid-cols-2 gap-4">
          {[
            { name: 'has_trash_room', label: 'Local poubelle' },
            { name: 'has_guard_lodge', label: 'Loge gardien' },
            { name: 'has_technical_room', label: 'Salle technique' },
          ].map(({ name, label }) => (
            <label key={name} className="flex items-center gap-2">
              <input
                type="checkbox"
                name={name}
                checked={property?.[name] ?? formData[name] ?? false}
                onChange={handleInputChange}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
      </FormField>
    </div>
  );
};
